module.exports = __webpack_public_path__ + "static/img/icp.5cbc1753.jpg";